import axios from "axios";

class RiskAPI {
  async getDepartements() {
    return await axios.get(
      `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/zone/departments/geojson`
   
      
    );
  }
}

export default RiskAPI;
